<style scoped lang="scss">
   .expand-row{
      margin-bottom: 16px;
      background: rgba(0,120,0,.10);
   }
</style>
<template>
   <div>
      <div class="expand-row">
            <div span="8">
               <span class="expand-key">Job: </span>
               <span class="expand-value">{{ row.job }}</span>
            </div>
            <div span="8">
               <span class="expand-key">Interest: </span>
               <span class="expand-value">{{ row.interest }}</span>
            </div>
            <div span="8">
               <span class="expand-key">Birthday: </span>
               <span class="expand-value">{{ row.birthday }}</span>
            </div>
      </div>
      <div>
            <div span="8">
               <span class="expand-key">Favorite book: </span>
               <span class="expand-value">《{{ row.book }}》</span>
            </div>
            <div span="8">
               <span class="expand-key">Favorite movie: </span>
               <span class="expand-value">{{ row.movie }}</span>
            </div>
            <div span="8">
               <span class="expand-key">Favorite music: </span>
               <span class="expand-value">{{ row.music }}</span>
            </div>
      </div>
   </div>
</template>
<script>
   export default {
      props: {
            row: Object
      }
   };
</script>